module.exports = __webpack_public_path__ + "img/slogan_bco.33746417.svg";